// extracted by mini-css-extract-plugin
export default {"duyuruOutlet":"DuyuruOutlet_duyuruOutlet__Dpudj","fade":"DuyuruOutlet_fade__lJgYn","duyuruOutletHeader":"DuyuruOutlet_duyuruOutletHeader__YESUs"};